import { AspectRatio, Button, Divider, Image } from '@mantine/core'
import classes from './Result.module.css'
import { RingLoader } from '../Round/RingLoader'
import { ReactComponent as Trophy } from '../../assets/trophy.svg'
import clsx from 'clsx'
import Time from '../../common/components/time/Time'
import { Match } from '../../matches/api'
import { Link, useLocation } from 'react-router'
import { useMediaQuery } from '@mantine/hooks'
import { Typography } from '../../common/typography'
import dayjs from 'dayjs'

export default function Result({
  match,
  baseLink,
}: {
  match: Match
  baseLink?: string
}) {
  const location = useLocation()
  const isDesktop = useMediaQuery('(min-width: 800px)')
  const hasWatch = !!match.video?.main

  return (
    <div className={classes.container}>
      <div className={classes.result_container}>
        {match.round_status === 'ended' && (
          <div className={classes.result_description_wrapper}>
            <Typography fs="sm" lh="120" ta="center">
              FULL-TIME
              <br />
              {`${dayjs(match.round_start).format('D MMM')} - ${dayjs(match.round_start).add(6, 'day').format('D MMM')}`}
            </Typography>
          </div>
        )}
        {match.round_status === 'upcoming' && (
          <div className={classes.result_description_wrapper}>
            <Typography fs="sm" lh="120">
              UPCOMING
            </Typography>
          </div>
        )}
        {match.round_status === 'live' && (
          <div className={classes.result_description_wrapper}>
            <div className={classes.active_result_container}>
              <RingLoader />
              <Typography fs="sm" lh="120">
                NOW-PLAYING
              </Typography>
            </div>
            <Time />
          </div>
        )}
        <Divider orientation="vertical" className={classes.divider} />
        <div className={classes.wrapper}>
          <div className={classes.team_container}>
            <AspectRatio ratio={1 / 1}>
              <Image
                src={
                  isDesktop
                    ? match.home_team_logo.thumbnail
                    : match.home_team_logo.mini
                }
                alt={match.home_team_name}
                className={clsx(classes.team_logo, {
                  [classes.team_logo_mobile]: !isDesktop,
                })}
                fit="scale-down"
              />
            </AspectRatio>
            <Typography
              fw={match.home_team_score > match.away_team_score ? 600 : 400}
              lh="150"
            >
              {match.home_team_name}
            </Typography>
          </div>
          <div className={classes.team_container}>
            <AspectRatio ratio={1 / 1}>
              <Image
                src={
                  isDesktop
                    ? match.away_team_logo.thumbnail
                    : match.away_team_logo.mini
                }
                alt={match.away_team_name}
                className={clsx(classes.team_logo, {
                  [classes.team_logo_mobile]: !isDesktop,
                })}
                fit="scale-down"
              />
            </AspectRatio>
            <Typography
              fw={match.away_team_score > match.home_team_score ? 600 : 400}
              lh="150"
            >
              {match.away_team_id == null ? 'BYE' : match.away_team_name}
            </Typography>
          </div>
        </div>
        <Divider orientation="vertical" className={classes.divider} />
        {match.round_status === 'upcoming' ? (
          <Typography ta="right" ff="JetBrains Mono" fw={700} lh="150">
            {match.round_start}
          </Typography>
        ) : (
          <div className={classes.wrapper}>
            <div
              className={clsx(classes.score_container, {
                [classes.without_winner]: !(
                  match.home_team_score > match.away_team_score &&
                  match.round_status === 'ended'
                ),
              })}
            >
              {match.home_team_score > match.away_team_score &&
                match.round_status === 'ended' && (
                  <Trophy
                    className={clsx(classes.trophy, {
                      [classes.trophy_mobile]: !isDesktop,
                    })}
                  />
                )}
              <Typography ta="right" ff="JetBrains Mono" fw={700} lh="150">
                {match.home_team_score}
              </Typography>
            </div>
            <div
              className={clsx(classes.score_container, {
                [classes.without_winner]: !(
                  match.away_team_score > match.home_team_score &&
                  match.round_status === 'ended'
                ),
              })}
            >
              {match.away_team_score > match.home_team_score &&
                match.round_status === 'ended' && (
                  <Trophy
                    className={clsx(classes.trophy, {
                      [classes.trophy_mobile]: !isDesktop,
                    })}
                  />
                )}
              <Typography ta="right" ff="JetBrains Mono" fw={700} lh="150">
                {match.away_team_score}
              </Typography>
            </div>
          </div>
        )}
      </div>
      {match.round_status === 'ended' && (
        <div className={classes.finished_container}>
          {hasWatch && (
            <Button
              component={Link}
              to={`${baseLink}/watch`}
              state={{ from: location }}
              className={clsx(classes.button, classes.watch_button)}
            >
              <Typography
                fc={{ light: 'primary-5', dark: 'gray-3' }}
                fs="sm"
                lh="150"
                ta="center"
              >
                Watch Match
              </Typography>
            </Button>
          )}
          <Button
            component={Link}
            to={`${baseLink}/summary`}
            state={{ from: location }}
            className={classes.button}
          >
            <Typography
              fc={{ light: 'white', dark: 'white' }}
              fs="sm"
              lh="150"
              ta="center"
            >
              Match Stats
            </Typography>
          </Button>
        </div>
      )}
    </div>
  )
}
